import { track } from "jiffy-analytics";
import { track as rudderstackTrack } from "common/utils/rudderstack/tracker";
import EventClass from "common/utils/ui/event-class";

// eslint-disable-next-line import/prefer-default-export
export class ProductFilterLinkClass extends EventClass {
  #linkSelector = "";

  #baseURL = "";

  constructor(props) {
    super(props);

    this.#linkSelector = props.eventSelector;
  }

  static $input($target) {
    return $target.querySelector("input");
  }

  static updateCheckedState($target) {
    const $input = ProductFilterLinkClass.$input($target);
    if (!$input) return;

    const isChecked = $input.checked;
    if ($input.type === "checkbox") {
      if (isChecked) {
        $input.removeAttribute("checked");
        $input.checked = false;
      } else {
        $input.setAttribute("checked", "checked");
        $input.checked = true;
      }
    } else if ($input.type === "radio") {
      const radios = document.querySelectorAll(`input[name="${$input.name}"]`);
      radios.forEach($radio => {
        if ($radio === $input) {
          $radio.setAttribute("checked", "checked");
        } else {
          $radio.removeAttribute("checked");
        }
        $radio.checked = $radio === $input; // eslint-disable-line no-param-reassign
      });
    }
  }

  get $links() {
    return document.querySelectorAll(this.#linkSelector);
  }

  get #serializedQueryURL() {
    // Use the most recently clicked link's href as base, or current URL as fallback
    const baseURL = new URL(this.#baseURL || window.location.href);
    const url = new URL(baseURL.pathname || "/", window.location.origin);

    // Get all filter param names that exist in the links
    const filterParamNames = new Set(
      Array.from(this.$links)
        .map($link => ProductFilterLinkClass.$input($link)?.name)
        .filter(Boolean)
    );

    // Preserve all params from base URL except filter params
    baseURL.searchParams.forEach((value, key) => {
      if (!filterParamNames.has(key)) {
        url.searchParams.append(key, value);
      }
    });

    // Add all checked filter params (supports multiple values per param)
    Array.from(this.$links).forEach($link => {
      const $input = ProductFilterLinkClass.$input($link);
      if ($input?.checked) {
        url.searchParams.append($input.name, $input.value);
      }
    });

    return url.toString();
  }

  get #activeFilterItems() {
    return Array.from(this.$links).filter($link => {
      const $input = ProductFilterLinkClass.$input($link);
      return $input?.checked;
    });
  }

  manualSubmit() {
    this.#activeFilterItems.forEach(ProductFilterLinkClass.sendClickEvent);
    window.location.href = this.#serializedQueryURL;
  }

  event(event, $target) {
    super.event(event, $target);

    event.preventDefault();
    event.stopPropagation();

    // Store the clicked link's href as the base URL for building the final URL
    this.#baseURL = $target.href;

    ProductFilterLinkClass.updateCheckedState($target);
  }

  static sendClickEvent($target) {
    const { mixpanelEvent, mixpanelData } = $target.dataset;
    let parsedData;
    try {
      parsedData = JSON.parse(mixpanelData || "{}");
    } catch (error) {
      console.error("Failed to parse mixpanel data:", error);
      parsedData = {};
    }

    track(mixpanelEvent, parsedData);

    const $anyLineItem = document.querySelector(".js-item-details-tracker");
    const pageName = $anyLineItem?.dataset?.pageName;
    rudderstackTrack("Navigation Clicked", {
      destination: $target.href,
      is_app: Boolean(window.MOBILE_APP),
      location: pageName || window.location.pathname,
      platform: window.MOBILE_APP_PLATFORM || "web",
      text: parsedData.filter_name,
      type: "link",
      url: window.location.href,
      nav_type: "side_nav"
    });
  }
}
